module.exports = __webpack_public_path__ + "img/hardyDrillRelease1.49b08e84.png";